import { render, staticRenderFns } from "./cowLactationYield.vue?vue&type=template&id=413c6f4e&scoped=true&"
import script from "./cowLactationYield.vue?vue&type=script&lang=js&"
export * from "./cowLactationYield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c6f4e",
  null
  
)

export default component.exports